export const calculateNetPrice = (originalPrice: number, discount: number, increase: number): number => {
  const discountedPrice = originalPrice * ((100 - discount) / 100);
  const finalPrice = discountedPrice * ((100 + increase) / 100);
  return parseFloat(finalPrice.toFixed(2));
};
